import React, { useState, useEffect } from "react";
import { LeadViewDetailsViewFullInfoProps } from "./customer-view-details-view-full-info.props";
import "./customer-view-details-view-full-info.scss";
import { formatDate, formatDateTime } from "../../../../../../utils/utils";
import ContactLink from "../../../../../../common/components/contact-link/contact-link";
import { useLogin } from "../../../../../../common/hooks/useUser";
import { useResourcePermissions } from "../../../../../../common/hooks/resource-permissions";
import MODULES from "../../../../../../constants/modules";
import CallOverDuePopup from "../../../../../../common/components/call-over-due-popup/call-over-due-popup";
import { fetchOverDueCallsWithCustomerId, fetchOverDueCallsWithLeadId } from "../../../../../../api/campaign";
import { convertToMinutes } from "../../../../../../utils/utils";

const CustomerViewDetailsViewFullInfo: React.FC<
  LeadViewDetailsViewFullInfoProps
> = (props: any) => {
  const { customerDetails, viewFullInfoOpen, setViewFullInfoOpen, permissions,isMobile } =
    props;
  const [isViewOpen, setIsViewOpen] = useState<boolean>(true);
  const handleEditOpen = () => setViewFullInfoOpen(!viewFullInfoOpen);
  const { tenantDetails } = useLogin();
  const [selectedCallStatus, setSelectedCallStatus] = useState<string>("");
  const [isOverDueCall, setIsOverDueCall] = useState<boolean>(false);
  const [initialCall, setInitialCall] = useState<any>();

  const checkIsDisableEdit = () => {
    return tenantDetails?.tenantType === "Tenant" &&
      customerDetails?.lead_status === "Closed-Lost" &&
      customerDetails?.lead_source === "AFP"
      ? true
      : false;
  };

    useEffect(() => {
      if (customerDetails?.id) { 
        const fetchOverDueCalls = async () => {
          try {
            const response = await fetchOverDueCallsWithCustomerId(customerDetails.id);
            if (response?.data?.data?.id) {
              setInitialCall(response?.data?.data);
              setIsOverDueCall(true) // Delay to ensure the call is overdue
            } else {
              setIsOverDueCall(false);
            }
          } catch (error) {
            console.error("Error fetching overdue calls:", error);
            setIsOverDueCall(false);
          }
        };
        fetchOverDueCalls();
  
      }
    }, [customerDetails]);
  

  return (
    <div className="customer-list-view-details-view-box-full-info">
      {!isMobile && (
      <div className="customer-list-view-details-view-box-full-info-header">
        <div>Details</div>
        <div>
          {isViewOpen ? (
            <i
              className="fa fa-angle-down"
              onClick={() => {
                setIsViewOpen(!isViewOpen);
              }}
            />
          ) : (
            <i
              className="fa fa-angle-up"
              onClick={() => {
                setIsViewOpen(!isViewOpen);
              }}
            />
          )}
        </div>
      </div>
      )}
      {isViewOpen ? (
        <>
          <div className="customer-list-view-details-view-box-full-info-header-text-edit">
            <div className="customer-list-view-details-view-box-full-info-header-text">
              Customer Information
            </div>
            <div className="customer-list-view-details-view-box-full-info-header-edit">
              <button
                className="customer-list-view-edit-section"
                onClick={handleEditOpen}
                disabled={checkIsDisableEdit() || !permissions?.canWrite}
              >
                Edit
              </button>
            </div>
          </div>
          <div className="customer-list-view-details-view-box-full-info-data">
            <div className="customer-list-view-details-view-box-full-info-data-section">
              <div className="customer-list-view-details-view-box-full-info-data-section-main-sub">
                <div className="customer-list-view-details-view-box-full-info-data-section-main">
                  First Name
                </div>
                <div className="customer-list-view-details-view-box-full-info-data-section-sub">
                  {customerDetails?.first_name || "-"}
                </div>
              </div>
              <div className="customer-list-view-details-view-box-full-info-data-section-main-sub">
                <div className="customer-list-view-details-view-box-full-info-data-section-main">
                  Last Name
                </div>
                <div className="customer-list-view-details-view-box-full-info-data-section-sub">
                  {customerDetails?.last_name || "-"}
                </div>
              </div>
              <div className="customer-list-view-details-view-box-full-info-data-section-main-sub">
                <div className="customer-list-view-details-view-box-full-info-data-section-main">
                  Date of Birth
                </div>
                <div className="customer-list-view-details-view-box-full-info-data-section-sub">
                  {formatDate(customerDetails?.dob) || "-"}
                </div>
              </div>
              <div className="customer-list-view-details-view-box-full-info-data-section-main-sub">
                <div className="customer-list-view-details-view-box-full-info-data-section-main">
                  Phone Number
                </div>
                <ContactLink
                  type="Phone"
                  id={customerDetails?.id}
                  value={customerDetails?.primary_phone_number || "-"}
                  className="customer-list-view-details-view-box-full-info-data-section-sub"
                />
              </div>
              <div className="customer-list-view-details-view-box-full-info-data-section-main-sub">
                <div className="customer-list-view-details-view-box-full-info-data-section-main">
                  Modified By
                </div>
                <div className="customer-list-view-details-view-box-full-info-data-section-sub">
                  {customerDetails?.updatedBy || "-"}
                  <br />
                  {formatDateTime(customerDetails?.updated_at || "-", true)}
                </div>
              </div>
            </div>
            <div className="customer-list-view-details-view-box-full-info-data-section">
              <div className="customer-list-view-details-view-box-full-info-data-section-main-sub">
                <div className="customer-list-view-details-view-box-full-info-data-section-main">
                  Middle Name
                </div>
                <div className="customer-list-view-details-view-box-full-info-data-section-sub">
                  {customerDetails?.middle_name || "-"}
                </div>
              </div>
              <div className="customer-list-view-details-view-box-full-info-data-section-main-sub">
                <div className="customer-list-view-details-view-box-full-info-data-section-main">
                 Customer Owner
                </div>
                <div className="customer-list-view-details-view-box-full-info-data-section-sub">
                   {customerDetails?.customerOwner?.first_name || ""}{" "}
                  {customerDetails?.customerOwner?.last_name || ""}
                </div>
              </div>
              <div className="customer-list-view-details-view-box-full-info-data-section-main-sub">
                <div className="customer-list-view-details-view-box-full-info-data-section-main">
                  Lead Source
                </div>
                <div className="customer-list-view-details-view-box-full-info-data-section-sub">
                  {customerDetails?.lead_source || "-"}
                </div>
              </div>
              <div className="customer-list-view-details-view-box-full-info-data-section-main-sub">
                <div className="customer-list-view-details-view-box-full-info-data-section-main">
                  Email
                </div>
                <ContactLink
                  type="Email"
                  id={customerDetails?.id}
                  value={customerDetails?.primary_email_address || "-"}
                  className="customer-list-view-details-view-box-full-info-data-section-sub"
                />
              </div>
              <div className="customer-list-view-details-view-box-full-info-data-section-main-sub">
                <div className="customer-list-view-details-view-box-full-info-data-section-main">
                  Created By
                </div>
                <div className="customer-list-view-details-view-box-full-info-data-section-sub">
                  {customerDetails?.createdBy || "-"}
                  <br />
                  {formatDateTime(customerDetails?.created_at || "-", true)}
                </div>
              </div>
            </div>
          </div>
          <div className="customer-list-view-details-view-box-full-info-header-text">
            Address
          </div>
          <div
            style={{
              display: "flex",
               gap: isMobile ? "2rem" : "0px",
              alignItems: "center",
              marginBottom: "8px",
            }}
          >
            <div style={{ flex: 1 }} className="customer-address-header-text">
              Mailing Address
            </div>
            {!isMobile && (
            <div style={{ flex: 1 }} className="customer-address-header-text">
              Permanent Address
            </div>
            )}
          </div>
          <div
            className="customer-list-view-details-view-box-full-info-data"
            style={{ display: "flex", gap: "2rem" }}
          >
            {/* Mailing Address */}
            <div
              className="customer-list-view-details-view-box-full-info-data-section adress-border"
              style={{ flex: 1 }}
            >
              <div className="customer-list-view-details-view-box-full-info-data-section-main-sub">
                <div className="customer-list-view-details-view-box-full-info-data-section-main">
                  Street Line 1
                </div>
                <div className="customer-list-view-details-view-box-full-info-data-section-sub">
                  {customerDetails?.mailingAddress?.street_line_1 || "-"}
                </div>
              </div>
              <div className="customer-list-view-details-view-box-full-info-data-section-main-sub">
                <div className="customer-list-view-details-view-box-full-info-data-section-main">
                  Street Line 2
                </div>
                <div className="customer-list-view-details-view-box-full-info-data-section-sub">
                  {customerDetails?.mailingAddress?.street_line_2 || "-"}
                </div>
              </div>
              <div className="customer-list-view-details-view-box-full-info-data-section-main-sub">
                <div className="customer-list-view-details-view-box-full-info-data-section-main">
                  State
                </div>
                <div className="customer-list-view-details-view-box-full-info-data-section-sub">
                  {customerDetails?.mailingAddress?.state || "-"}
                </div>
              </div>
              <div className="customer-list-view-details-view-box-full-info-data-section-main-sub">
                <div className="customer-list-view-details-view-box-full-info-data-section-main">
                  City
                </div>
                <div className="customer-list-view-details-view-box-full-info-data-section-sub">
                  {customerDetails?.mailingAddress?.city || "-"}
                </div>
              </div>
              <div className="customer-list-view-details-view-box-full-info-data-section-main-sub">
                <div className="customer-list-view-details-view-box-full-info-data-section-main">
                  Country
                </div>
                <div className="customer-list-view-details-view-box-full-info-data-section-sub">
                  {customerDetails?.mailingAddress?.country || "-"}
                </div>
              </div>
              <div className="customer-list-view-details-view-box-full-info-data-section-main-sub">
                <div className="customer-list-view-details-view-box-full-info-data-section-main">
                  Zip Code
                </div>
                <div className="customer-list-view-details-view-box-full-info-data-section-sub">
                  {customerDetails?.mailingAddress?.zipcode || "-"}
                </div>
              </div>
            </div>
            {/* Permanent Address */}
            {isMobile && (
            <div style={{ flex: 1 }} className="customer-address-header-text customer-responsive-text">
              Permanent Address
            </div>
            )}
            <div
              className="customer-list-view-details-view-box-full-info-data-section adress-border"
              style={{ flex: 1 }}
            >
              <div className="customer-list-view-details-view-box-full-info-data-section-main-sub">
                <div className="customer-list-view-details-view-box-full-info-data-section-main">
                  Street Line 1
                </div>
                <div className="customer-list-view-details-view-box-full-info-data-section-sub">
                  {customerDetails?.permanentAddress?.street_line_1 || "-"}
                </div>
              </div>
              <div className="customer-list-view-details-view-box-full-info-data-section-main-sub">
                <div className="customer-list-view-details-view-box-full-info-data-section-main">
                  Street Line 2
                </div>
                <div className="customer-list-view-details-view-box-full-info-data-section-sub">
                  {customerDetails?.permanentAddress?.street_line_2 || "-"}
                </div>
              </div>
              <div className="customer-list-view-details-view-box-full-info-data-section-main-sub">
                <div className="customer-list-view-details-view-box-full-info-data-section-main">
                  State
                </div>
                <div className="customer-list-view-details-view-box-full-info-data-section-sub">
                  {customerDetails?.permanentAddress?.state || "-"}
                </div>
              </div>
              <div className="customer-list-view-details-view-box-full-info-data-section-main-sub">
                <div className="customer-list-view-details-view-box-full-info-data-section-main">
                  City
                </div>
                <div className="customer-list-view-details-view-box-full-info-data-section-sub">
                  {customerDetails?.permanentAddress?.city || "-"}
                </div>
              </div>
              <div className="customer-list-view-details-view-box-full-info-data-section-main-sub">
                <div className="customer-list-view-details-view-box-full-info-data-section-main">
                  Country
                </div>
                <div className="customer-list-view-details-view-box-full-info-data-section-sub">
                  {customerDetails?.permanentAddress?.country || "-"}
                </div>
              </div>
              <div className="customer-list-view-details-view-box-full-info-data-section-main-sub">
                <div className="customer-list-view-details-view-box-full-info-data-section-main">
                  Zip Code
                </div>
                <div className="customer-list-view-details-view-box-full-info-data-section-sub">
                  {customerDetails?.permanentAddress?.zipcode || "-"}
                </div>
              </div>
            </div>
          </div>

          <div className="customer-list-view-details-view-box-full-info-header-text">
            Description
          </div>
          <div className="customer-list-view-details-view-box-full-info-description-box description-box-container">
            {customerDetails?.description || "-"}
          </div>
        </>
      ) : (
        ""
      )}
      <CallOverDuePopup
        open={isOverDueCall}
        title={`${convertToMinutes(initialCall?.delayed)} minutes late for the call.`}
        onCancel={() => {setIsOverDueCall(false); }}
        onOkay={() => { }}
        selectedCallStatus={selectedCallStatus}
        setSelectedCallStatus={setSelectedCallStatus}
        isCustomer={true}
        details={customerDetails}
      />
    </div>
  );
};

export default CustomerViewDetailsViewFullInfo;
